export default function ProductDetailsSkeleton() {
  return (
    <div className="min-h-screen space-y-4 pb-24">
      <div className="grid grid-cols-1 space-y-4 md:grid-cols-2">
        <section className="relative min-h-[50vh] animate-pulse bg-[#F0E0C7]/40" />

        <div>
          <section className="bg-white p-4">
            <div className="h-5 w-28 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="mt-3 flex flex-wrap gap-2">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={index}
                  className="h-10 w-20 animate-pulse rounded-full bg-[#F0E0C7]/60"
                />
              ))}
            </div>
          </section>

          <section className="bg-white px-4 py-5">
            <div className="h-8 w-3/4 max-w-sm animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="mt-3 flex items-end gap-2">
              <div className="h-7 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
              <div className="h-5 w-16 animate-pulse rounded bg-[#F0E0C7]/60" />
            </div>
            <div className="mt-3 h-5 w-40 animate-pulse rounded bg-[#F0E0C7]/60" />
          </section>

          <section className="bg-white px-4 py-5">
            <div className="h-7 w-36 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="mt-4 space-y-2">
              <div className="h-4 w-full animate-pulse rounded bg-[#F0E0C7]/60" />
              <div className="h-4 w-full animate-pulse rounded bg-[#F0E0C7]/60" />
              <div className="h-4 w-5/6 animate-pulse rounded bg-[#F0E0C7]/60" />
            </div>
          </section>

          <section className="bg-white px-4 py-5">
            <div className="h-7 w-40 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="mt-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="h-12 w-12 animate-pulse rounded-full bg-[#F0E0C7]/60" />
                <div className="h-5 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
              </div>
              <div className="h-9 w-24 animate-pulse rounded-full bg-[#F0E0C7]/60" />
            </div>
          </section>
        </div>
      </div>

      <footer className="fixed bottom-0 z-10 flex w-full gap-3 border-t border-[#ebe7e2] bg-white px-4 py-4">
        <div className="h-12 flex-1 animate-pulse rounded-full bg-[#F0E0C7]/60" />
        <div className="h-12 flex-1 animate-pulse rounded-full bg-[#F0E0C7]/60" />
      </footer>
    </div>
  );
}
